// extracted by mini-css-extract-plugin
export default {"card_wrap":"HomeCardWrap_card_wrap__QkJOF","breadcrumbs":"HomeCardWrap_breadcrumbs__wVzxx"};